import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchCompanies } from "./actionCreator";

export const reportsTitleBarSlice = createSlice({
  name: "reportsTitleBar",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*-------------------------------- get share drive Pending State ---------------------------------*/
    builder.addCase(fetchCompanies.pending, (state) => {
      state.isLoading = true;
      state.error = "";
      state.companies = [];
    });
    builder.addCase(fetchCompanies.fulfilled, (state, action) => {
      state.companies = action.payload?.data?.company;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(fetchCompanies.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || "";
      state.isError = true;
    });
  },
});

export default reportsTitleBarSlice.reducer;
